

































import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ICompany } from "@/models/company.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters: {}
})
export default class CompanySheet extends mixins(PermissionMixin) {
  @Prop()
  company!: ICompany;

  @Prop({ default: "grey lighten-4" })
  color!: string;

  goToDetail() {
    if (this.canReadCompany) {
      this.company.goTo(this.$router).detail();
    }
  }
}
